import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

type Props = {
  onRegenerate: () => void;
  isLoading: boolean;
};

export function StaleDataBanner({ onRegenerate, isLoading }: Props) {
  return (
    <div className="flex items-center justify-between gap-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 dark:border-amber-700 dark:bg-amber-950/30">
      <div className="flex items-center gap-2 text-sm text-amber-800 dark:text-amber-200">
        <AlertTriangle className="size-4 shrink-0" />
        <span>Ci sono nuovi dati da quando hai visto il riepilogo. Vuoi aggiornarlo?</span>
      </div>
      <Button variant="outline" size="sm" onClick={onRegenerate} isLoading={isLoading}>
        Aggiorna
      </Button>
    </div>
  );
}
